const REVIEW_POLL_DELAY_MIN_MS = 15_000;
const REVIEW_POLL_DELAY_MAX_MS = 30_000;

export function getReviewPollDelayMs(random = Math.random): number {
  return REVIEW_POLL_DELAY_MIN_MS + Math.floor(random() * (REVIEW_POLL_DELAY_MAX_MS - REVIEW_POLL_DELAY_MIN_MS + 1));
}
